<ng-container [formGroup]="metadataFormGroup">
  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations Véhicule Entreprise
  </div>

  <!-- Use the existing vehicle form component for vehicle-specific fields -->
  <app-lead-vehicle-form [formGroup]="vehicleFormGroup" #vehicleForm />
</ng-container>
